/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PodcastPlayer_podcast$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type Podcasts_podcasts$ref: FragmentReference;
declare export opaque type Podcasts_podcasts$fragmentType: Podcasts_podcasts$ref;
export type Podcasts_podcasts = $ReadOnlyArray<{|
  +$fragmentRefs: PodcastPlayer_podcast$ref,
  +$refType: Podcasts_podcasts$ref,
|}>;
export type Podcasts_podcasts$data = Podcasts_podcasts;
export type Podcasts_podcasts$key = $ReadOnlyArray<{
  +$data?: Podcasts_podcasts$data,
  +$fragmentRefs: Podcasts_podcasts$ref,
  ...
}>;
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "Podcasts_podcasts",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PodcastPlayer_podcast"
    }
  ],
  "type": "PodcastType",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '449a9464cc1b5de3135e8d8a3618fb7f';

module.exports = node;
